export default __webpack_public_path__ + "pinterest-sign.png";